import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDashed, faPlus } from '@fortawesome/pro-light-svg-icons';

import UserIconList from 'components/user_icon_list';

interface Props {
  assignee?: { name: string };
}

export default function Assignee({ assignee }: Props) {
  return (
    <div>
      {assignee
        ? (
          <div className="d-flex align-items-center gap-1">
            <UserIconList users={[assignee]} />
            <div>{assignee.name}</div>
          </div>
        ) : (
          <span className="apex-tasks-list__assignee-placeholder clickable fa-stack">
            <FontAwesomeIcon className="fa-stack-2x text-muted" icon={faCircleDashed} />
            <FontAwesomeIcon className="fa-stack-1x" icon={faPlus} />
          </span>
        )}
    </div>
  );
}
